/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
*/

import axios from 'axios';
// import QS from 'qs';
// import store from '../store/index'
import { Toast } from "vant";


// 环境切换
// if (process.env.NODE_ENV == 'development') {
//   axios.defaults.baseURL = '/api'
// } else if (process.env.NODE_ENV == 'debug') {
//   axios.defaults.baseURL = 'https://dev.vwingist.com'
// } else if (process.env.NODE_ENV == 'production') {
//   axios.defaults.baseURL = 'https://dev.vwingist.com'
// }
const axiosInstance = axios.create({
  timeout: 15000,
  baseURL: process.env.VUE_APP_BASE_API
});
// 请求超时时间
axiosInstance.defaults.timeout = 100001

// post请求头
// 请求拦截
axiosInstance.interceptors.request.use(config => {
  // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
  if (config.headers.requestBase == 'VUE_APP_BASE_API_TWO') {
    config.baseURL = process.env.VUE_APP_BASE_API_TWO; // 取到环境变量：baseURL
  }
  return config;
},
  error => {
    return Promise.error(error)
  }
)

// 响应拦截
axiosInstance.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response.data);
      // if (response.data.result || response.data.error_code == 0  || response.config.params.Method == "getuser") {
      //   return Promise.resolve(response.data);
      // } else {
      //   if (response.data.error_code == 2) {
      //     Toast({
      //       message: 'method参数不正确',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 3) {
      //     Toast({
      //       message: '订单号不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 4) {
      //     Toast({
      //       message: '分派员姓名不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 5) {
      //     Toast({
      //       message: '分派员工号不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 6) {
      //     Toast({
      //       message: '分派员联系方式（手机号）不能为空！',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 7) {
      //     Toast({
      //       message: '不可重复分派员扫码',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 8) {
      //     Toast({
      //       message: '当前位置不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 9) {
      //     Toast({
      //       message: '取餐员姓名不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 10) {
      //     Toast({
      //       message: '取餐员工号不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 11) {
      //     Toast({
      //       message: '取餐员联系方式（手机号）不能为空！',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 12) {
      //     Toast({
      //       message: '不可重复取餐',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 13) {
      //     Toast({
      //       message: 'appkey或者appsecret不正确',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 14) {
      //     Toast({
      //       message: '片区id不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 15) {
      //     Toast({
      //       message: '订单ID不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 16) {
      //     Toast({
      //       message: '服务订单状态不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 17) {
      //     Toast({
      //       message: '服务订单情况属性不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 18) {
      //     Toast({
      //       message: '店铺名称不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 19) {
      //     Toast({
      //       message: '店铺地址不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 20) {
      //     Toast({
      //       message: '店铺位置不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 21) {
      //     Toast({
      //       message: '订单内容不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 22) {
      //     Toast({
      //       message: '订单价格不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 23) {
      //     Toast({
      //       message: '送达方式不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 24) {
      //     Toast({
      //       message: '点餐用户（顾客）手机号不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 25) {
      //     Toast({
      //       message: '送餐地址不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 26) {
      //     Toast({
      //       message: '地址所属区域不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 27) {
      //     Toast({
      //       message: '配送费不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 28) {
      //     Toast({
      //       message: '不可重复提交',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else if(response.data.error_code == 29) {
      //     Toast({
      //       message: 'id不能为空',
      //       duration: 1500,
      //       forbidClick: true
      //     });
      //   }else {
      //     return Promise.resolve(response.data);
      //   }
      // }
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况    
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录                
        // 未登录则跳转登录页面，并携带当前页面的路径                
        // 在登录成功后返回当前页面，这一步需要在登录页操作。                
        case 401:
          this.$router.replace({
            path: '/login/1',
            query: { redirect: this.$router.currentRoute.fullPath }
          });
          break;
        // 403 token过期                
        // 登录过期对用户进行提示                
        // 清除本地token和清空vuex中token对象                
        // 跳转登录页面                
        case 403:
          this.$Toast({
            message: '登录过期，请重新登录',
            duration: 1000,
            forbidClick: true
          });
          // 清除token                    
          // localStorage.removeItem('token');
          // store.commit('loginSuccess', null);
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            this.$router.replace({
              path: '/login/1',
              query: {
                redirect: this.$router.currentRoute.fullPath
              }
            });
          }, 1000);
          break;
        // 404请求不存在                
        case 404:
          Toast({
            message: '网络请求不存在',
            duration: 1500,
            forbidClick: true
          });
          break;
        // 其他错误，直接抛出错误提示                
        default:
          Toast({
            message: '接口请求失败',
            // message: error.response.data.message,
            duration: 1500,
            forbidClick: true
          });
      }
      return Promise.reject(error.response);
    }
  }
);

export default axiosInstance;